import { createFileRoute, Outlet } from "@tanstack/react-router";
import { redirectIfModuleDisabled } from "@/lib/module-guards";

export const Route = createFileRoute("/_authorized/team/notifications")({
	beforeLoad: () => redirectIfModuleDisabled("notifications"),
	component: () => <Outlet />,
});
